import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getRetailPurchaseApi(data) {
  return request({
    url: '/GetRetailPurchase',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function getRetailPurchaseUnProductApi(data) {
  return request({
    url: '/getRetailPurchaseUnProduct',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function addRetailPurchaseApi(data) {
  return request({
    url: '/AddRetailPurchase',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function updateRetailPurchaseApi(data) {
  return request({
    url: '/UpdateRetailPurchase',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function delRetailPurchaseApi(data) {
  return request({
    url: '/DelRetailPurchase',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function getRetailProductOutApi(data) {
  return request({
    url: '/GetRetailProductOut',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function getRetailProductOutUnSellApi(data) {
  return request({
    url: '/GetRetailProductOutUnSell',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function addRetailProductOutApi(data) {
  return request({
    url: '/AddRetailProductOut',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function updateRetailProductOutApi(data) {
  return request({
    url: '/UpdateRetailProductOut',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function delRetailProductOutApi(data) {
  return request({
    url: '/DelRetailProductOut',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function getRetailProductInApi(data) {
  return request({
    url: '/GetRetailProductIn',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function getRetailProductInUnFinishProduct(data) {
  return request({
    url: '/GetRetailProductInUnFinishProduct',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function addRetailProductInApi(data) {
  return request({
    url: '/AddRetailProductIn',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function updateRetailProductInApi(data) {
  return request({
    url: '/UpdateRetailProductIn',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function delRetailProductInApi(data) {
  return request({
    url: '/DelRetailProductIn',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function getRetailSellApi(data) {
  return request({
    url: '/GetRetailSell',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function addRetailSellApi(data) {
  return request({
    url: '/AddRetailSell',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function updateRetailSellApi(data) {
  return request({
    url: '/UpdateRetailSell',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function delRetailSellApi(data) {
  return request({
    url: '/DelRetailSell',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function getRetailFinanceApi(data) {
  return request({
    url: '/GetRetailFinance',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function addRetailFinanceApi(data) {
  return request({
    url: '/AddRetailFinance',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function updateRetailFinanceApi(data) {
  return request({
    url: '/UpdateRetailFinance',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function delRetailFinanceApi(data) {
  return request({
    url: '/DelRetailFinance',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function getRetailPurchaseInApi(data) {
  return request({
    url: '/GetRetailPurchaseIn',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function addRetailPurchaseInApi(data) {
  return request({
    url: '/AddRetailPurchaseIn',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function updateRetailPurchaseInApi(data) {
  return request({
    url: '/UpdateRetailPurchaseIn',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}

export function delRetailPurchaseInApi(data) {
  return request({
    url: '/DelRetailPurchaseIn',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 99001,
      MessageID: btcguid(),
      Data: data
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/retail.js